import { PencilAltIcon } from "@heroicons/react/solid";

const EditIcon = () => {
  return (
    <PencilAltIcon className="h-5 w-5 text-neutralColor-light hover:text-neutralColor-normal cursor-pointer" />
  );
};

export default EditIcon;
